module.exports = __webpack_public_path__ + "img/Dantam Hair 40.a40c40c4.jpg";